// PRODUCTS / ATHLETES image switch used across product-card sections
// (featured collections, the main collection grid, related products):
// picks whether cards show their first image (PRODUCTS, the default) or
// their second image (ATHLETES) by default. Markup: a .collection-image-toggle
// group holding two .collection-image-toggle__option buttons with
// data-toggle-value="off" (PRODUCTS) / "on" (ATHLETES). State lives only in
// the DOM (aria-pressed / .is-active on the options + an .image-toggle-on
// class on the section's product wrapper named by data-collection-target) —
// nothing is persisted, so a refresh always comes back to PRODUCTS.
//
// On mobile there is no tap-to-preview while ATHLETES is on — the card
// just shows the second image, full stop, and tapping it navigates
// normally like any other product card. (Whatever preview-on-tap effect
// you see on PRODUCTS is the site's separate, pre-existing default card
// behavior — untouched by this file either way.)
if (!window.__collectionImageToggleBound) {
  window.__collectionImageToggleBound = true;

  function setToggle(group, on) {
    group.querySelectorAll('.collection-image-toggle__option').forEach(function (option) {
      var active = (option.getAttribute('data-toggle-value') === 'on') === on;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-pressed', String(active));
    });

    var target = document.getElementById(group.getAttribute('data-collection-target'));
    if (target) target.classList.toggle('image-toggle-on', on);
  }

  document.addEventListener('click', function (event) {
    var option = event.target.closest('.collection-image-toggle__option');
    if (!option) return;

    var group = option.closest('.collection-image-toggle');
    if (!group) return;

    setToggle(group, option.getAttribute('data-toggle-value') === 'on');
  });

  // Some mobile browsers (notably iOS Safari) restore a page from their
  // back/forward cache exactly as it was left — including this script's
  // DOM changes — instead of doing a fresh load, so a plain page-load
  // reset never runs. Catch that case explicitly and go back to PRODUCTS.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      document.querySelectorAll('.collection-image-toggle').forEach(function (group) {
        setToggle(group, false);
      });
    }
  });
}
